import React, {Fragment, useEffect, useContext} from 'react';
import {Redirect} from 'react-router-dom';

import withClass from '../../../hoc/withClass';
import context from '../../../context/auth-context';
import Aside from './Aside/Aside';
import Main from './Main/Main';

const Settings = () => {

    document.body.className = 'app-notebook page-aside-scroll page-aside-left';
    const authContext = useContext(context);

    useEffect(() => {
        if(document.getElementById('skintools')) 
            document.getElementById('skintools').style.display = 'block';

        return () => {
            if(document.getElementById('skintools')) document.getElementById('skintools').style.display = 'none';
        }
    }, []);

    return (
        <Fragment>
            {!authContext.authenticated && <Redirect to="/" />}
            <Aside />
            <Main />
        </Fragment>
    );
};

export default withClass(Settings, 'page bg-white');